import React, { useCallback } from "react";
import MRMLogo from "../../../assets/images/LogoMRM-HD.png";
import MRMname from "../../../assets/images/murillo-HD.png";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

import SearchBar from "../SearchBar/SearchBar";
import colors from "../../colors";
import { Box, IconButton } from "@mui/material";

interface HeaderProps {
	OnClick?: () => void;
	PopAdd: (AddSelection: string) => void;
	onSearch: (searchTerm: string) => void;
}

export const Header: React.FC<HeaderProps> = ({
	OnClick,
	PopAdd,
	onSearch,
}) => {
	const handleSearch = useCallback(
		(searchValue: string) => {
			onSearch(searchValue);
		},
		[onSearch]
	);

	return (
		<Box
			sx={{
				position: "fixed",
				width: "100%",
				height: "100%",
				maxHeight: "5rem",
				backgroundColor: colors.white,
				display: "flex",
				borderBottom: `2px solid ${colors.primaryGreen}`,
				alignItems: "center",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
				<IconButton onClick={OnClick}>
					<MenuRoundedIcon
						sx={{ color: colors.deepGreen, fontSize: "2.5rem" }}
					/>
				</IconButton>
				<img
					src={MRMLogo}
					alt="MRM Logo"
					style={{
						width: "3rem",
						height: "3rem",
					}}
				/>
				<img
					src={MRMname}
					alt="MRM Name"
					style={{
						width: "12rem",
						height: "1rem",
					}}
				/>
			</Box>
			<Box
				sx={{
					display: "flex",
					paddingRight: "2rem",
					width: "100%",
					justifyContent: "flex-end",
				}}
			>
				<SearchBar onSearch={handleSearch} />
			</Box>
		</Box>
	);
};

export default Header;
